import 'angular-moment-picker';
import { module } from 'angular';
import { GmcDatePickerComponent } from './gmc-date-picker.component';
import { gmcDatePickerBtnDirective } from './gmc-date-picker-btn.directive';
import { gmcDatePickerInputDirective } from './gmc-date-picker-input.directive';
import { gmcDatepickerConfig } from './gmc-date-picker.config';

export const GmcDatePickerModule = module('app.shared.gmc-date-picker', [
  'moment-picker'
])
  .component('gmcDatePicker', GmcDatePickerComponent)
  .directive('gmcDatePickerBtn', gmcDatePickerBtnDirective)
  .directive('gmcDatePickerInput', gmcDatePickerInputDirective)
  .config(gmcDatepickerConfig);



// WEBPACK FOOTER //
// ./app/shared/components/gmc-date-picker/gmc-date-picker.module.ts